import "core-js/stable";
import "regenerator-runtime/runtime";
const $ = require("jquery");
global.$ = global.jQuery = $;

const bootstrap = require("bootstrap");
global.bootstrap = bootstrap;

require("select2");
require("select2/dist/js/i18n/fr");
import { initSelect2 } from "./select2";

require("slick-carousel");
import { initSlick } from "./slick";


$(function () {
  navBarToggle();
  initSelect2();
  initSlick();
  initFilter();
  initComments();
});

const navBarToggle = () => {
  const navBarToggleBtn = document.querySelector(".navbar-toggler");
  navBarToggleBtn.addEventListener("click", function () {
    if (navBarToggleBtn.classList.contains("collapsed")) {
      document.querySelector(".navbar-toggler").innerHTML = `<i class="fas fa-times"></i>`
      $(".navbar-custom-collapse-wrapper").slideDown({
        start: function () {
          $(this).css({
            display: "flex"
          })
        }
      });
    } else {
      document.querySelector(".navbar-toggler").innerHTML = `<i class="fas fa-bars"></i>`
      $(".navbar-custom-collapse-wrapper").slideUp();
    }
    navBarToggleBtn.classList.toggle("collapsed");
  });
}

const initFilter = () => {
  $("#annee").on("change", function () {
    $.ajax({
      type: "GET",
      url: `${this.dataset.site}/evenements`,
      data: {"annee": this.value },
      success: function (response) {
        $('#loading').fadeIn();
        let content = document.createElement("html");
        content.innerHTML = response;
        let newContent = content.querySelector(".index-section");
        document.querySelector(".index-section").replaceWith(newContent);
        $('#loading').fadeOut();
      }
    });
  })
}

const initAjaxLoading = () => {
  $(document)
    .ajaxStart(function () {
      $('#loading').fadeIn();
    })
    .ajaxStop(function () {
      $('#loading').fadeOut();
    });
}

const initComments = () => {
  $(".answer-btn").on("click", function () {
    $(`#child-comment-form-${this.dataset.childFormId}`).toggle();
  });

  $(".child-comment-form").on("click", "button[type='reset']", function () {
    $(this).closest(".child-comment-form").toggle();
  });

}
